(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-cart-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!form.matches('[data-bb-cu-form]')) return;
      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const label = form.querySelector('.bb-cu__add-label');
      if (!button || !label) return;

      const original = label.textContent;
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'Adding';

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: form.querySelector('input[name="id"]').value,
              quantity: 1,
            }],
          }),
        });
        if (!response.ok) throw new Error('Add to cart failed');

        label.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(() => {
          label.textContent = original;
          button.removeAttribute('aria-busy');
        }, 1500);
      } catch (error) {
        label.textContent = 'Try again';
        button.removeAttribute('aria-busy');
        setTimeout(() => { label.textContent = original; }, 2000);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
